import { Nav, NavItem, Button } from "reactstrap";

import { Link, useLocation } from "react-router-dom";
import "./StaffSidebar.css";

const navigation = [
  {
    title: "Properties",
    href: "/",
    icon: "bi bi-building",
  },
  {
    title: "Booking",
    href: "/student-dashboard/contracts",
    icon: "bi bi-file-text",
  },
];

const StudentSidebar = () => {
  let location = useLocation();

  const closeSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  return (
    <div className="p-3">
      {/* Mobile close button - only visible on small screens */}
      <div className="d-flex justify-content-end d-lg-none mb-2">
        <Button
          color="link"
          size="sm"
          className="text-dark p-1"
          onClick={closeSidebar}
          style={{ border: 'none' }}
        >
          <i className="bi bi-x-lg" style={{ fontSize: '1.2rem', color: '#000' }}></i>
        </Button>
      </div>
      
      <div className="d-flex align-items-center">
        {/* <Logo /> */}
      </div>
      <div className="pt-4 mt-2">
        <Nav vertical className="sidebarNav">
          {navigation.map((navi, index) => (
            <NavItem key={index} className="sidenav-bg">
              <Link
                to={navi.href}
                className={
                  location.pathname === navi.href
                    ? "nav-link py-3"
                    : "nav-link py-3"
                }
                style={{ color: "#000" }}
              >
                <i className={navi.icon} style={{ color: "#000" }}></i>
                <span className="ms-3 d-inline-block" style={{ 
                  fontSize: navi.title.length > 12 ? "12px" : "inherit",
                  fontWeight: navi.title.length > 12 ? "600" : "normal"
                }}>{navi.title}</span>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </div>
    </div>
  );
};

export default StudentSidebar;
